import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { getApiUrl } from '../config/api';

const SAMPLE_LISTINGS = [
  { id: 1, title: 'Maize Farm - North Region', location: 'Bamenda, Cameroon', crop: 'Maize', risk: 'A', return: '12%', size: '5 ha', image: 'https://images.unsplash.com/photo-1625246333195-78d9c38ad449?w=600&q=80' },
  { id: 2, title: 'Rice Paddy - South Region', location: 'Douala, Cameroon', crop: 'Rice', risk: 'B', return: '10%', size: '5 ha', image: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=600&q=80' },
  { id: 3, title: 'Vegetable Farm - Central', location: 'Yaoundé, Cameroon', crop: 'Vegetables', risk: 'A', return: '14%', size: '2 ha', image: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=600&q=80' },
  { id: 4, title: 'Livestock - West Region', location: 'Bafoussam, Cameroon', crop: 'Cattle', risk: 'C', return: '8%', size: '10 ha', image: 'https://images.unsplash.com/photo-1500595046743-cd271d694d30?w=600&q=80' },
  { id: 5, title: 'Cocoa Plantation', location: 'Kribi, Cameroon', crop: 'Cocoa', risk: 'B', return: '11%', size: '8 ha', image: 'https://images.unsplash.com/photo-1574943320219-553eb213f72d?w=600&q=80' },
  { id: 6, title: 'Mixed Crop Farm', location: 'Garoua, Cameroon', crop: 'Maize & Beans', risk: 'A', return: '13%', size: '6 ha', image: 'https://images.unsplash.com/photo-1625246333195-78d9c38ad449?w=600&q=80' },
];

function Marketplace() {
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ full_name: '', phone: '', email: '', interests: '' });
  const [submitting, setSubmitting] = useState(false);
  const [formMessage, setFormMessage] = useState(null);

  const handleInvestorSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setFormMessage(null);
    try {
      const res = await fetch(getApiUrl('/api/investors/register'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (data.success) {
        setFormMessage({ type: 'success', text: data.message || 'Registration received! We will contact you soon.' });
        setForm({ full_name: '', phone: '', email: '', interests: '' });
        setShowForm(false);
      } else {
        setFormMessage({ type: 'error', text: data.message || 'Registration failed.' });
      }
    } catch (err) {
      setFormMessage({ type: 'error', text: err.message || 'Request failed.' });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <section className="page-hero">
        <h1>Farm Investment Marketplace</h1>
        <p>Browse AI-evaluated farm opportunities with transparent risk ratings and expected returns.</p>
        {!showForm ? (
          <button className="btn btn-primary" style={{ marginTop: '0.5rem' }} onClick={() => setShowForm(true)}>
            Register as Investor
          </button>
        ) : (
          <div className="investor-form-wrap" style={{ marginTop: '1rem', maxWidth: '400px', textAlign: 'left' }}>
            <form className="contact-form" onSubmit={handleInvestorSubmit}>
              {formMessage && (
                <p style={{ color: formMessage.type === 'success' ? 'var(--accent-green)' : '#c62828', marginBottom: '0.75rem' }}>
                  {formMessage.text}
                </p>
              )}
              <div className="form-group">
                <label>Full Name *</label>
                <input type="text" required value={form.full_name} onChange={(e) => setForm({ ...form, full_name: e.target.value })} />
              </div>
              <div className="form-group">
                <label>WhatsApp Phone *</label>
                <input type="tel" placeholder="e.g. 237652499810" required value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
              </div>
              <div className="form-group">
                <label>Email</label>
                <input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
              </div>
              <div className="form-group">
                <label>Investment Interests</label>
                <input type="text" placeholder="e.g. crops, livestock, North region" value={form.interests} onChange={(e) => setForm({ ...form, interests: e.target.value })} />
              </div>
              <button type="submit" className="btn btn-primary" disabled={submitting}>{submitting ? 'Submitting...' : 'Submit'}</button>
              <button type="button" className="btn btn-outline" style={{ marginLeft: '0.5rem' }} onClick={() => setShowForm(false)}>Cancel</button>
            </form>
          </div>
        )}
      </section>

      <section className="section">
        <div className="section-header">
          <h2>Available Investment Opportunities</h2>
          <p>Each farm is evaluated by our AI Risk Engine. Select farms to fund and track your investment.</p>
        </div>
        <div className="listing-grid">
          {SAMPLE_LISTINGS.map((listing) => (
            <div key={listing.id} className="listing-card">
              <img src={listing.image} alt={listing.title} style={{ width: '100%', height: '200px', objectFit: 'cover' }} />
              <div className="card-body">
                <span className={`risk-badge risk-${listing.risk.toLowerCase()}`}>Risk {listing.risk}</span>
                <h3>{listing.title}</h3>
                <p style={{ fontSize: '0.9rem', color: 'var(--text-muted)', marginBottom: '0.5rem' }}>{listing.location}</p>
                <p style={{ marginBottom: '0.5rem' }}><strong>Crop:</strong> {listing.crop} • {listing.size}</p>
                <p style={{ fontWeight: 600, color: 'var(--accent-green)' }}>Expected Return: {listing.return}</p>
                <Link to="/contact" className="btn btn-primary" style={{ marginTop: '1rem', display: 'inline-block' }}>Fund This Farm</Link>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}

export default Marketplace;
